export default __webpack_public_path__ + "static/facebook-62d087e74df6d3aa0fd09bbdc3b18f31.png";